import { imageNames } from "@/src/constants/imageConstants.js";

export const dealTabs = [
  { title: "Activity" },
  { title: "Notes" },
  { title: "Email" },
  { title: "Calls" },
  { title: "Tasks" },
  { title: "Meetings" },
  { title: "Livechat" },
];

export const defaultPipelineStages = [
  {
    name: "Qualification",
    order_index: 0,
    probability: "OPEN",
    weightPercentage: 10,
    editable: false,
  },
  {
    name: "Discovery",
    order_index: 1,
    probability: "OPEN",
    weightPercentage: 20,
    editable: true,
  },
  {
    name: "Demo scheduled",
    order_index: 2,
    probability: "OPEN",
    weightPercentage: 30,
    editable: true,
  },
  {
    name: "Demo given",
    order_index: 3,
    probability: "OPEN",
    weightPercentage: 40,
    editable: true,
  },
  {
    name: "Negotiation",
    order_index: 4,
    probability: "OPEN",
    weightPercentage: 50,
    editable: true,
  },
  {
    name: "Deal Won",
    order_index: 5,
    probability: "WON",
    weightPercentage: 100,
    editable: true,
  },
  {
    name: "Deal Lost",
    order_index: 6,
    probability: "LOST",
    weightPercentage: 0,
    editable: true,
  },
];

export const dealsMoreMenuItemsMap = {
  EDIT_DEAL: "edit_deal",
  DELETE_DEAL: "delete_deal",
};

export const dealsMoreMenuItems = [
  {
    key: dealsMoreMenuItemsMap.EDIT_DEAL,
    icon: imageNames.EDIT,
    text: "Edit",
  },
  {
    key: dealsMoreMenuItemsMap.DELETE_DEAL,
    icon: imageNames.DELETE_GREY,
    text: "Delete",
  },
];

export const dealStages = {
  QUALIFICATION: "Qualification",
  DISCOVERY: "Discovery",
  DEMO_SCHEDULED: "Demo scheduled",
  DEMO_GIVEN: "Demo given",
  NEGOTIATION: "Negotiation",
  WON: "Deal Won",
  LOST: "Deal Lost",
};
